module.exports = __webpack_public_path__ + "img/voucher.811f41f3.svg";